// src/components/SEO/FAQSection.jsx
import React from 'react';
import FAQSchema from './FAQSchema';

const FAQSection = ({ title, questions, className = '' }) => {
    if (!questions || questions.length === 0) return null;

    return (
        <>
            <FAQSchema questions={questions} />
            <section className={`py-12 px-4 ${className}`}>
                <div className="container mx-auto max-w-4xl">
                    {title && (
                        <h2 className="text-2xl md:text-3xl font-bold text-center text-gradpath-dark mb-8">
                            {title}
                        </h2>
                    )}
                    <div className="space-y-3">
                        {questions.map((faq, index) => (
                            <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-white">
                                <details className="group">
                                    <summary className="flex justify-between items-center w-full px-6 py-4 text-left font-semibold text-gray-800 cursor-pointer hover:bg-gray-50 transition">
                                        <span>{faq.question}</span>
                                        <span className="text-gradpath-green group-open:rotate-180 transition-transform duration-200">
                                            <i className="fas fa-chevron-down"></i>
                                        </span>
                                    </summary>
                                    <div className="px-6 pb-4 text-gray-600 leading-relaxed">
                                        {faq.answer}
                                    </div>
                                </details>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default FAQSection;